// app/translate/index.ts

export * from './translate.service';
export * from './translations';
export * from './translate.pipe';
export * from './translate.module';